import { apiClient } from '../../../lib/api/client';
import type {
  OfferingDetail,
  OfferingFormValues,
  OfferingListItem,
  GetOfferingsParams,
  PagedResult,
} from '../types';

export async function getOfferings(
  params: GetOfferingsParams = {}
): Promise<PagedResult<OfferingListItem>> {
  const {
    pageNumber = 1,
    pageSize = 10,
    search,
    status,
    hasActiveDiscount,
    minBasePrice,
    maxBasePrice,
    offeringCategoryId,
  } = params;

  const searchParams = new URLSearchParams();
  searchParams.set('pageNumber', String(pageNumber));
  searchParams.set('pageSize', String(pageSize));

  if (search !== undefined && search !== '') searchParams.set('search', search);
  if (status !== undefined) searchParams.set('status', String(status));
  if (hasActiveDiscount !== undefined) searchParams.set('hasActiveDiscount', String(hasActiveDiscount));
  if (minBasePrice !== undefined) searchParams.set('minBasePrice', String(minBasePrice));
  if (maxBasePrice !== undefined) searchParams.set('maxBasePrice', String(maxBasePrice));
  if (offeringCategoryId !== undefined) searchParams.set('offeringCategoryId', offeringCategoryId);

  const response = await apiClient.get<PagedResult<OfferingListItem>>(
    `/offerings?${searchParams.toString()}`
  );
  return response.data;
}

export async function getOfferingById(id: string): Promise<OfferingDetail> {
  const response = await apiClient.get<OfferingDetail>(`/offerings/${id}`);
  return response.data;
}

export async function createOffering(data: OfferingFormValues): Promise<{ id: string }> {
  const response = await apiClient.post<{ id: string }>('/offerings', {
    name: data.name,
    description: data.description ?? null,
    basePrice: data.basePrice,
    status: data.status,
    offeringCategoryId: data.offeringCategoryId,
    discountType: data.discountType ?? null,
    discountValue: data.discountValue ?? null,
    discountStart: data.discountStart ?? null,
    discountEnd: data.discountEnd ?? null,
  });
  return response.data;
}

export async function deleteOffering(id: string): Promise<void> {
  await apiClient.delete(`/offerings/${id}`);
}

export async function updateOffering(id: string, data: OfferingFormValues): Promise<void> {
  await apiClient.put(`/offerings/${id}`, {
    name: data.name,
    description: data.description ?? null,
    basePrice: data.basePrice,
    status: data.status,
    offeringCategoryId: data.offeringCategoryId,
    discountType: data.discountType ?? null,
    discountValue: data.discountValue ?? null,
    discountStart: data.discountStart ?? null,
    discountEnd: data.discountEnd ?? null,
  });
}
